import { cn } from '@moreharvest/component-library';

interface DesktopAuthWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    $width?: string;
}

const baseWrapperClasses = cn(
    'flex flex-col mt-8 w-full px-4 gap-y-12',
    'w-full lg:h-full lg:max-w-[unset] lg:min-w-[unset]',
    'lg:m-auto lg:inline-flex lg:py-12 lg:px-6 lg:rounded-2xl lg:border-1'
);

const DesktopAuthWrapper = ({
    className,
    $width = '424px',
    style,
    ...props
}: DesktopAuthWrapperProps) => (
    <div
        {...props}
        className={cn(
            baseWrapperClasses,
            'lg:bg-neutral-50 lg:border-neutral-200 dark:lg:bg-neutral-50-dark dark:lg:border-neutral-200-dark',
            className
        )}
        style={{
            ...style,
            width: $width,
        }}
    />
);

export default DesktopAuthWrapper;
